<template>
  <div class="col px-0 d-flex flex-column">
    <div class="header">
      <div class="d-flex flex-row">
        <h1 class="content-title">
          {{ $t("label.attendance_list") }} {{ title }}
        </h1>
      </div>
      <div class="d-flex flex-row">
        <attendance-tabs
          :active-tab="activeTab"
          :privilege="privilege"
          @changeTab="changeTab"
        ></attendance-tabs>
        <attendance-search
          @showOnlySelected="handleShowOnlySelected"
          @search="updateSearchText"
        ></attendance-search>
      </div>
    </div>
    <attendance-list
      :article-id="articleId"
      :active-tab="activeTab"
      :search-text="searchText"
      :show-only-selected="showOnlySelected"
      @loaded="updateChildComponents"
    ></attendance-list>
  </div>
</template>

<script>
import attendanceTabs from "@/components/admin/view/attendance/tabs";
import attendanceList from "@/components/admin/view/attendance/list";
import attendanceSearch from "@/components/admin/view/attendance/search";

export default {
  components: {
    attendanceTabs,
    attendanceList,
    attendanceSearch
  },
  data() {
    return {
      title: "Default Title",
      activeTab: "redeemList",
      searchText: "",
      privilege: {},
      showOnlySelected: false
    };
  },
  computed: {
    articleType() {
      return this.$route.params.articleType;
    },
    articleId() {
      return this.$route.params.articleId;
    }
  },
  methods: {
    changeTab(to) {
      this.activeTab = to;
    },
    updateChildComponents(article) {
      this.title = article.title;
      this.privilege = article.privilege;
    },
    updateSearchText(text) {
      this.searchText = text;
    },
    handleShowOnlySelected(value) {
      this.showOnlySelected = value;
    }
  }
};
</script>

<style lang="sass" scoped>
.header {
  padding: 0px 30px;
  padding-top: 20px;
  text-align: left;
  height: 110px;
  border-bottom: 1px solid #e0e0e0;
}
.content-title {
  font-size: 24px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: -0.1px;
  color: $black;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  height: auto;
  padding: 0;
}
.sc-tabs {
  margin-top: 12px;
}
</style>
